import {
  VORGANG_QES_UPDATED_FROM_SOCKET_EVENT,
  VORGANG_UPDATED_RECORD_ID_FROM_SOCKET_EVENT,
} from "../../../constants/socketConstants";

const initialState = {
  vorgangUpdatedRecordId: null,
  vorgangQESUpdatedRecordId: null,
};

const socketReducer = (state, action) => {
  if (typeof state === "undefined") {
    state = initialState;
  }
  switch (action.type) {
    case VORGANG_UPDATED_RECORD_ID_FROM_SOCKET_EVENT:
      return Object.assign({}, state, {
        vorgangUpdatedRecordId: action.recordId,
      });
    case VORGANG_QES_UPDATED_FROM_SOCKET_EVENT:
      return Object.assign({}, state, {
        vorgangQESUpdatedRecordId: action.recordId,
      });
    default:
      return state;
  }
};

export default socketReducer;
